<template>
  <el-card
    v-if="ready"
    class="inline-goal-card inline-goal-float-effect"
    body-style="padding: 0px">

    <div class="inline-goal-card__image" :style="background_image_css">

      <el-rate
        :value="goal.isFavorite * 1"
        :max="1"
        @change="onMakeFavorite"
        style="position: absolute; right: 5px; top: 5px"/>

      <router-link class="inline-goal-card__section" :to="'/goal/' + goal.$id + '/dashboard'">
        <!-- v-tooltip="{ content: 'Go to Dashboad: ' + goal_meta.name }" -->
        <span>Dashboad</span>
      </router-link>

      <!--
      <router-link class="inline-goal-card__section" :to="'/goal/' + goal.$id + '/kanban'" v-tooltip="{ content: 'Go to Tasklist: ' + goal_meta.name }">
        <span>Tasklist</span>
      </router-link>
      -->
    </div>
    <div class="inline-goal-card__content">
      <!--
      <router-link :to="'/goal/'+goal.$id+'/dashboard'" v-tooltip="{ content: 'Go to ' + goal_meta.name }">
      </router-link>
      -->

      <inline-editable-text
        class="twolinetext mr-2"
        style="min-width: 100px;"
        @change="onUpdateGoalName"
        :value="goal_meta.name"
        :inline="true"
        :reset-on-update="false"
        :reset-on-cancel="false"
        :lost-focus-is-update="false"
        />

      <ellipsis-button
        class=""
        v-if="!is_deleted"
        heading="Goal Actions"
        :show-options="['edit', 'slot', 'archive', 'delete']"
        @edit="onGoToGoalSettings()"
        @archive="onDeleteGoal( true )"
        @delete="onDeleteGoal( false )">

        <el-button
          class="btn-block ml-0"
          size="mini"
          @click.prevent="onInviteUser" >
          <font-awesome-icon :icon="['fas', 'user-plus']" class="taskicon" />
          Invite user
        </el-button>

        <el-button
          class="btn-block ml-0"
          size="mini"
          @click.prevent="onLeaveGoal" >
          <font-awesome-icon icon="sign-out-alt" class="taskicon" />
          Leave goal
        </el-button>

        <!--
        <template v-if="!currentUserIsOwner">
          <font-awesome-icon :disabled="goal_is_deleting" icon="sign-out-alt" class="laneicon" title="leave lane"
              @click.prevent="onClickLeaveLane(goalId, true)" />
        </template>

        <template v-if="currentUserIsAdmin">
          <font-awesome-icon :disabled="goal_is_deleting" icon="trash-alt" class="laneicon" title="delete lane"
              @click.prevent="onClickDeleteLane(goalId, true)" />
        </template>
        -->
      </ellipsis-button>
      <ellipsis-button
        v-else
        heading="Goal Actions"
        :show-options="['restore', 'delete']"
        @restore="onRestoreGoal"
        @delete="onDeleteGoal( false )">
      </ellipsis-button>
    </div>
    <div class="inline-goal-card__invite" >
      <template v-if="is_teamgoal && !is_deleted">
        <img
          v-for="(member, memberId) in goal_meta.members" :key="memberId"
          class="user-image"
          :src="member.cachedProfilePic|defaultUserPic"
          width="24"
          height="24"
          v-tooltip="{ content: member.cachedName }"/>
        <el-button type="text" style="padding-left: 1em" @click="onInviteUser">
          <font-awesome-icon :icon="['fas', 'user-plus']" /> Invite
        </el-button>
      </template>
      <template v-else-if="is_deleted">
        <strong style="color: var(--red)">You achieved or deleted this goal.</strong>
        <!-- <el-button variant="danger" @click="onDeleteGoal( false )">Remove</el-button> -->
      </template>
    </div>

  </el-card>
</template>

<script>
import EllipsisButton from '@/components/Elements/EllipsisButton'
import InvitePromptMixin from '@/components/Mixins/Prompts/InvitePrompt'
import ConfirmDeletePromptMixin from "@/components/Mixins/Prompts/ConfirmDeletePrompt"
import GoalManagementMixin from "@/components/Mixins/GoalManagement"

// TODO: We need a $ready_goal id triiger, when goal was just created

export default {
  mixins: [ InvitePromptMixin, ConfirmDeletePromptMixin, GoalManagementMixin ],
  props: {
    goal: { required: true }
  },
  computed: {
    ready() {
      /* This is required when we create goals after goals have been loaded */
      return this.$api.get_ready( 'goal:' + this.goal.$id )
    },
    goalId() {
      return this.goal.$id;
    },
    goal_meta() {
      return this.$models.goalMeta.getNode( this.goal.$id );
    },
    is_deleted() {
      return this.goal_meta.deleted;
    },
    is_teamgoal() {
      return this.goal_meta.isTeamgoal;
    },
    background_image_css() {
      return this.goal_meta.picture
              ? {
                backgroundImage: 'url(' + this.goal_meta.picture + ')',
                backgroundSize: 'cover'
              } : {}
    },
  },
  methods: {
    onMakeFavorite() {
      console.log("onMakeFavorite", this.goal.isFavorite)
      this.$models.userGoalSettings.update( this.goalId, {
        isFavorite: !this.goal.isFavorite
      })
    },
  },
  components: {
    EllipsisButton,
  }
}
</script>

<style>
.inline-goal-card {
  width: 211px; /* = 130px image height * Golden Ratio (1.62) */
  height: 211px; /* = 1:1 */
  float: left;
  margin-left: 0.5em;
  margin-right: 0.5em;
  margin-bottom: 0.5em;
  cursor: pointer;
}
.inline-goal-float-effect:hover {
  /* margin-top: -4px;
  height: calc(211px + 4px); */
  box-shadow: 0 6px 12px 0 rgba(0, 0, 0, 0.15);
  position: relative;
  /* top: -2px; */
}
.inline-goal-float-effect:hover .inline-goal-card__image {
  filter: grayscale(0%);
}
.inline-goal-card__image {
  filter: grayscale(33%);
  width: 100%;
  height: 130px;
  display: block;
  min-height: 100px;
  background-color: gray;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  /* Default image */
  background-size: contain;
  background-image: url('../../../assets/goal_placeholder.png');
}
.inline-goal-card .user-image {
  border-radius: 100%;
  padding: 0;
  margin: 0;
  margin-left: -10px;
  border: 1px solid white;
}
.inline-goal-card__content {
  margin-top: 10px;
  margin-left: 14px;
  margin-right: 14px;
  max-height: 2em;
  /* overflow: hidden; */
  display: flex;
  justify-content: space-between;
}
.inline-goal-card__content::after {
  /* content: 'X'; */
}
.inline-goal-card__invite {
  display: flex;
  flex-wrap: wrap;
  padding-left: 14px;
  align-items: center;
}
.inline-goal-card__section {
  display: block;
  /*height: 50%;*/
  height: 100%;
  padding-top: 2em;
  text-align: center;
}
.inline-goal-card__section > * {
  display: none;
}
.inline-goal-card__section:hover {
  background-color: rgba(0, 0, 0, 0.5);
  text-decoration: none;
}
.inline-goal-card__section:hover > * {
  font-size: 12pt;
  padding-top: 18px;
  color: white;
  display: inherit;
}
</style>
